/* src/app/tip-ticket/pages/tip-ticket-edit/tip-ticket-edit.component.scss */
/*# sourceMappingURL=tip-ticket-edit.component.css.map */
